import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import { ExtraArgument, RootState } from "store";
import { errorHandler } from "../config";

export const pageSize = 25;

export const requestManagement = async (request: Function, dispatch: ThunkDispatch<RootState, ExtraArgument, AnyAction>, mock: string | undefined) => {
  try {
    return mock ? import(mock) : await request();
  } catch (error) {
    errorHandler(error, dispatch);
  }
}
